export const BASE_URL = 'https://tracker.omidrop.africa/api/';
// export const BASE_URL = 'http://127.0.0.1:8000/api/';